export enum EShelfMaterial
{
    /// <summary>
    /// Wood
    /// </summary>
    W = 1,
    /// <summary>
    /// Glass
    /// </summary>
    G = 2,
    /// <summary>
    /// Metal
    /// </summary>
    M = 3,
    /// <summary>
    /// Box
    /// </summary>
    B = 4,
}